Monitoring.Views ||= {}

class Monitoring.Views.PaginatorView extends Backbone.View
  template: JST["backbone/templates/paginator"]

  events: 'click .to_page': 'changedPage'

  initialize: (models, per_page) ->
    @paginator = new Monitoring.Models.ModelPaginator(models, per_page)
    @page = 1

  render: =>
    @$el.html(@template({ total_pages: @paginator.total_pages() }))
    @toggleActivePage(@page)
    @disablePreviousbutton()
    if @paginator.total_pages() == 1 then @disableNextbutton()
    @

  page: ->
    @toggleActivePage(@page)
    @paginator.page(@page)

  changedPage: (event) ->
    @selected_page = event.currentTarget.dataset.page;
    if @selected_page == 'previous'
      @enableNextbutton() if @page == @paginator.total_pages()
      @page = (parseInt(@page) - 1) if @page != 1
    else if @selected_page == 'next'
      @enablePreviousbutton() if @page == 1
      @page = (parseInt(@page) + 1) if @page != @paginator.total_pages()
    else
      @enableNextbutton() if @page == @paginator.total_pages()
      @enablePreviousbutton() if @page == 1
      @page = parseInt(@selected_page)
    @toggleActivePage(@page)
    @toggleDisabledButton(@page)
    @trigger('paginator:page_changed', @page)

  toggleActivePage: (page) ->
    @$el.find('.to_page').removeClass('active')
    @$el.find('.page_' + page).addClass('active')

  disableNextbutton: ->
    @$el.find('#next_page_button').addClass('to_page_disabled')

  enableNextbutton: ->
    @$el.find('#next_page_button').removeClass('to_page_disabled')

  disablePreviousbutton: ->
    @$el.find('#previous_page_button').addClass('to_page_disabled')

  enablePreviousbutton: ->
    @$el.find('#previous_page_button').removeClass('to_page_disabled')

  toggleDisabledButton: (page)->
    if page == 1
      @disablePreviousbutton()
    if page == @paginator.total_pages()
      @disableNextbutton()
